import axios from "axios";
import { getCookie } from "./constants";
import { BACKEND_URL, FMS_BACKEND_URL } from "./config";

const yaxios = axios.create({
  baseURL: FMS_BACKEND_URL,
});

yaxios.interceptors.request.use(
  (config) => {
    let cookie = getCookie("token");
    config.headers["Content-Type"] =
      config.data && config.data instanceof FormData
        ? "multipart/form-data"
        : "application/json";
    config.headers["Accept"] = "*/*";
    let newcookie = cookie ? cookie : "";
    if (newcookie.length > 0) {
      config.headers["Authorization"] = newcookie;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default yaxios;
